(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5432],{

/***/ 72957:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-openings",
      function () {
        return __webpack_require__(14988);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8158);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62286);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27307);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82352);
/* harmony import */ var _imports_files_pages_clients_careers_showJob__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51439);






function JobOpenings(param) {
    var job_data = param.job_data, status_code = param.status_code, title_hide = param.title_hide;
    var render_page_section = function render_page_section(page_section, index, formik, customizeCareerAction, hide_title) {
        var section_type = page_section.type;
        switch(section_type){
            // case 'about':
            //   return <About
            //     page_section={page_section}
            //     customizeCareerAction={customizeCareerAction}
            //     formik={formik}
            //     index={index}
            //     isPreview={true}
            //   />
            //   break;
            // case 'benefit':
            //   return <Benefit
            //     page_section={page_section}
            //     customizeCareerAction={customizeCareerAction}
            //     formik={formik}
            //     index={index}
            //     isPreview={true}
            //     />
            //   break;
            // case 'team':
            //   return <MeetTeam
            //     page_section={page_section}
            //     customizeCareerAction={customizeCareerAction}
            //     formik={formik}
            //     index={index}
            //     isPreview={true}
            //   />
            //   break;
            // case 'gallery':
            //   return <Gallery
            //     page_section={page_section}
            //     formik={formik}
            //     customizeCareerAction={customizeCareerAction}
            //     index={index}
            //     isPreview={true}
            //     />
            //   break;
            case "job":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_1__/* .OpenJobs */ .ry, {
                    isPreview: true,
                    formik: formik,
                    customizeCareerAction: customizeCareerAction,
                    index: index,
                    job_data: job_data,
                    isPublic: true,
                    page_section: page_section,
                    isFrame: true,
                    hide_title: hide_title
                });
                break;
        }
    };
    var router = (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_1__/* .useRouter */ .tv)();
    if (status_code != 200) return new _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_1__/* .ErrorPages */ .dC().renderPage(status_code, router);
    var career_page = job_data.career_page;
    var showJobAction = new _imports_files_pages_clients_careers_showJob__WEBPACK_IMPORTED_MODULE_2__/* .ShowJobAction */ .Ws();
    var customizeCareerAction = new _imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_1__/* .CustomizeCareerAction */ .jh({
        formRef: {
            current: {
                values: career_page
            }
        }
    });
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)(0), 2), flagForRender = ref[0], setFlagForRender = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_1__/* .useState */ .eJ)([]), 2), fonts = ref1[0], setFonts = ref1[1];
    var hide_title = title_hide;
    (0,_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_1__/* .useEffect */ .d4)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            customizeCareerAction.bannerSize();
            setFonts(customizeCareerAction.listofAllFonts(career_page));
            window.addEventListener("resize", function() {
                customizeCareerAction.bannerSize();
                setFlagForRender(Math.random() * 10000);
            });
            return [
                2,
                function() {
                    window.removeEventListener("resize", function() {
                        customizeCareerAction.bannerSize();
                    });
                }
            ];
        });
    }), []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            career_page.page_sections_attributes.map(function(page_section, index) {
                return render_page_section(page_section, index, {
                    values: career_page
                }, customizeCareerAction, hide_title);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_files_pages_career_customize_career_page__WEBPACK_IMPORTED_MODULE_1__/* .GoogleFontLoader */ .HZ, {
                fonts: fonts
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (JobOpenings);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2005,9441,1977,1436,9451,2419,3171,8411,7326,769,9072,6397,7843,8841,4080,6647,255,790,9774,2888,179], function() { return __webpack_exec__(72957); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);